import React, { useState, useCallback } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Box, IconButton } from "@mui/material";
import { Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ConfirmedStatusPopup from "../ConfirmedStatusPopup";
import "../../Order.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  heading: {
    fontSize: "23px",
    lineHeight: 1.3,
    marginRight: "1rem",
  },
  addOrderbtn: {
    padding: "4px 8px",
    fontSize: "13px",
    textTransform: "none",
    backgroundColor: "#ffffff",
  },
  statusBtn: {
    boxShadow: "none",
    textTransform: "none",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    border: "1px solid #8c8f94",
    borderRadius: "4px",
    padding: "0 8px",
    lineHeight: 2,
    height: "30px",
    marginRight: "1rem",
    backgroundColor: "#ffffff",
  },
  statusText: {
    // borderRight: '1px solid #000000',
    fontSize: "13px",
    color: "#646970",
    marginRight: "5px",
  },
  orderId: {
    color: "#2271b1",
    cursor: "pointer",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  bulkActions: {
    height: "32px",
    width: "12.5rem",
    backgroundColor: "#ffffff",
    fontSize: "14px",
    lineheight: 2,
    color: "#2c3338",
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      backgroundColor: "transparent",
    },
  },
  selectpaper: {
    width: "152px",
    boxShadow: "0px 0px 6px rgba(18 19 19 0.22)",
    borderRadius: "8px",
  },
  menuItem: {
    fontSize: "12px",
  },
  hold: {
    backgroundColor: "#f8dda7",
    color: "#94660c",
    boxShadow: "none",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#f8dda7",
      color: "#94660c",
      boxShadow: "none",
    },
  },
  completed: {
    backgroundColor: "#c8d7e1",
    color: "#2e4453",
    boxShadow: "none",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#c8d7e1",
      color: "#2e4453",
      boxShadow: "none",
    },
  },
  processing: {
    backgroundColor: "#c6e1c6",
    color: "#5b841b",
    boxShadow: "none",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#c6e1c6",
      color: "#5b841b",
      boxShadow: "none",
    },
  },
  cancelled: {
    color: "#777",
    backgroundColor: "#e5e5e5",
    boxShadow: "none",
    textTransform: "none",
    "&:hover": {
      color: "#777",
      backgroundColor: "#e5e5e5",
      boxShadow: "none",
    },
  },
  refunded: {
    backgroundColor: "#9b0202",
  },
  viewbtn: {
    border: "#D1D5DB solid 1px",
    textTransform: "none",
  },
  loading: {
    // height: '5px',
    color: "#c6e1c6",
  },
  popupcontainer: {
    ".css-1poimk-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper": {
      boxShadow: "none",
    },
  },
}));

const OrderStatus = (props) => {
  const { row, changedorderstatus, setChangedOrderStatus } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openConfirmedModal, setOpenConfiremdModal] = useState(false);
  const [status, setStatus] = useState("");
  const handleOpenMenu = useCallback(
    (event) => {
      setAnchorEl(anchorEl ? null : event.currentTarget);
    },
    [anchorEl]
  );

  const handleCloseMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleCloseConfirmedModal = useCallback((e, id) => {
    setOpenConfiremdModal(false);
  }, []);

  const handleStatusChange = useCallback((status) => {
    setStatus(status);
    setOpenConfiremdModal(true);
    setAnchorEl(null);
  }, []);

  console.log(row.status, row.id);
  return (
    <>
      <ConfirmedStatusPopup
        handleClose={handleCloseConfirmedModal}
        open={openConfirmedModal}
        id={row.id}
        status={status}
        setStatus={setStatus}
        changedorderstatus={changedorderstatus}
        setChangedOrderStatus={setChangedOrderStatus}
        row={row}
      />
      <Box
        display="flex"
        alignItems="center"
        className={classes.popupcontainer}
      >
        <Button
          variant="contained"
          size="small"
          // className={
          //   row.status === "processing"
          //     ? classes.processing
          //     : row.status === "completed"
          //     ? classes.completed
          //     : row.status === "on-hold"
          //     ? classes.hold
          //     : row.status === "cancelled" || row.status === "pending"
          //     ? classes.cancelled
          //     : classes.cancelled
          // }
          className={`order-status-button ${row.status}`}
          sx={{
            whiteSpace: "nowrap",
            fontSize: "11px",
            padding: "2px 6px",
            minWidth: "auto"
          }}
        >
          {row.status === "sendtoprint" ? "Send To Print" : row.status}
        </Button>
        <>
          <IconButton size="small" onClick={handleOpenMenu} sx={{ padding: "4px" }}>
            <MoreVertIcon sx={{ fontSize: "16px" }} />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
          >
            <MenuItem onClick={(e) => handleStatusChange("pending")}>
              Pending
            </MenuItem>
            <MenuItem onClick={(e) => handleStatusChange("processing")}>
              Processing
            </MenuItem>
            <MenuItem onClick={(e) => handleStatusChange("cancelled")}>
              Cancelled
            </MenuItem>
            <MenuItem onClick={(e) => handleStatusChange("changes-required")}>
              Changes Required
            </MenuItem>
            <MenuItem onClick={(e) => handleStatusChange("payment-pending")}>
              Payment Pending
            </MenuItem>
            <MenuItem onClick={(e) => handleStatusChange("on-hold")}>
              On-hold
            </MenuItem>
            <MenuItem onClick={(e) => handleStatusChange("mockup-sent")}>
              Mockup Sent
            </MenuItem>
            <MenuItem onClick={(e) => handleStatusChange("artwrok-missing")}>
              Artwork Missing
            </MenuItem>
            <MenuItem onClick={(e) => handleStatusChange("mockup-approved")}>
              Mockup Approved
            </MenuItem>
            <MenuItem onClick={(e) => handleStatusChange("sendtoprint")}>
              Send to Print
            </MenuItem>
            <MenuItem onClick={(e) => handleStatusChange("refund")}>
              Refunded
            </MenuItem>
          </Menu>
        </>
      </Box>
    </>
  );
};

export default OrderStatus;
